import { Component } from '@angular/core';
import { CommonService } from '../shared/common.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
constructor(public commonService:CommonService){  
}
}
